module.exports = __webpack_public_path__ + "static/media/home.6a4bb18b.svg";